import { render, staticRenderFns } from "./DiagnosticText.vue?vue&type=template&id=0b9e50ec&"
import script from "./DiagnosticText.vue?vue&type=script&lang=js&"
export * from "./DiagnosticText.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports